import SeoApi from './SeoApi';

class SeoService {
    constructor() {
        this.cache = new Map();
    }

    get(path) {
        if (this.cache.has(path)) {
            return this.cache.get(path);
        }

        const request = SeoApi.get(path);
        this.cache.set(
            path,
            request
        );

        return request;
    }


    clear(path = null) {
        if (path) {
            this.cache.delete(path);
            return;
        }

        this.cache.clear();
    }
}

export default new SeoService();